//import './style.css'
import EmblaCarousel from 'embla-carousel'

const emblaNode = document.querySelector('#embla') as HTMLElement | null

if (emblaNode) {
    const embla = EmblaCarousel(emblaNode, {
        loop: true,
        align: 'start'
    })

    const prevBtn = emblaNode.querySelector('.embla__prev') as HTMLButtonElement
    const nextBtn = emblaNode.querySelector('.embla__next') as HTMLButtonElement

    prevBtn.addEventListener('click', () => embla.scrollPrev())
    nextBtn.addEventListener('click', () => embla.scrollNext())

    const updateButtons = () => {
        prevBtn.disabled = !embla.canScrollPrev()
        nextBtn.disabled = !embla.canScrollNext()
    }

    embla.on('select', updateButtons)
    embla.on('init', updateButtons)
}


// Mobile menu functionality
const mobileMenuButton = document.querySelector('#mobile-menu-button') as HTMLButtonElement
const mobileMenu = document.querySelector('#mobile-menu') as HTMLElement

mobileMenuButton.addEventListener('click', () => {
    mobileMenu.classList.toggle('hidden')
})

// Team member modal functionality
const teamModal = document.querySelector('#team-modal') as HTMLElement
const modalImage = document.querySelector('#modal-image') as HTMLImageElement
const modalName = document.querySelector('#modal-name') as HTMLElement
const modalSubtitle = document.querySelector('#modal-subtitle') as HTMLElement
const modalDescription = document.querySelector('#modal-description') as HTMLElement
const closeModal = document.querySelector('#close-modal') as HTMLButtonElement

// Access teamData from global scope (defined in HTML)
declare const teamData: {
    [key: string]: {
        name: string;
        subtitle: string;
        image: string;
        description: string;
    }
}

// Open modal
document.querySelectorAll('.team-modal-btn').forEach(button => {
    button.addEventListener('click', () => {
        const member = button.getAttribute('data-member') as keyof typeof teamData
        if (member && teamData[member]) {
            const data = teamData[member]
            modalImage.src = data.image
            modalName.textContent = data.name
            modalSubtitle.textContent = data.subtitle
            modalDescription.textContent = data.description
            teamModal.classList.remove('hidden')
        }
    })
})

// Close modal
closeModal.addEventListener('click', () => {
    teamModal.classList.add('hidden')
})

// Close modal when clicking backdrop
teamModal.addEventListener('click', (e) => {
    if (e.target === teamModal) {
        teamModal.classList.add('hidden')
    }
})

// Smooth scrolling for navigation links
// document.querySelectorAll('.nav-link').forEach(link => {
//     link.addEventListener('click', (e) => {
//         e.preventDefault()
//         const targetId = link.getAttribute('href')?.substring(1)
//         const targetElement = document.getElementById(targetId || '')
//
//         if (targetElement) {
//             targetElement.scrollIntoView({
//                 behavior: 'smooth',
//                 block: 'start'
//             })
//
//             // Update active state
//             updateActiveNavLink(link as HTMLElement)
//         }
//     })
// })

// Update active navigation link
function updateActiveNavLink(activeLink: HTMLElement) {
    // Remove active class from all nav links
    document.querySelectorAll('.nav-link').forEach(link => {
        link.classList.remove('active')
    })

    // Add active class to current link
    activeLink.classList.add('active')
}

// Track scroll position and update active navigation
function updateActiveNavOnScroll() {
    const sections = ['home', 'about', 'approach', 'membership', 'contact']
    const scrollPosition = window.scrollY + 100 // Offset for fixed nav

    let activeSection = ''

    sections.forEach(sectionId => {
        const element = document.getElementById(sectionId)
        if (element) {
            const elementTop = element.offsetTop
            const elementBottom = elementTop + element.offsetHeight

            if (scrollPosition >= elementTop && scrollPosition < elementBottom) {
                activeSection = sectionId
            }
        }
    })

    // Find and activate the corresponding nav link
    const activeNavLink = document.querySelector(`.nav-link[href="#${activeSection}"]`) as HTMLElement
    if (activeNavLink) {
        updateActiveNavLink(activeNavLink)
    }
}

// Listen for scroll events
window.addEventListener('scroll', updateActiveNavOnScroll)

// Set initial active state
document.addEventListener('DOMContentLoaded', updateActiveNavOnScroll)
